import markdownit from 'markdown-it'
import hljs from 'highlight.js'
import markdownAnchor from 'markdown-it-anchor'
import markdownItCollapsible from 'markdown-it-collapsible'
import mathjax3 from 'markdown-it-mathjax3'
// import slugify from '@sindresorhus/slugify'
import 'highlight.js/styles/github-dark.css'
export interface Toc {
  slug: string
  title: string
  level: number
  tag: string
  children?: Toc[]
}
const toc: Toc[] = []
const flatToc: Toc[] = []
let tocLevels: number[] = [1, 2, 3]
const markdown: any = markdownit({
  html: true,
  xhtmlOut: false,
  linkify: true,
  langPrefix: 'language-',
  typographer: true,
  quotes: '“”‘’',
  breaks: true,
  highlight: function (str: string, lang: string) {
    const className = `language-${lang}`
    if (lang && hljs.getLanguage(lang)) {
      try {
        return (
          '<pre class=' +
          className +
          '><code class="hljs">' +
          hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
          '</code>' +
          '<small class="hljs-tag">' +
          lang +
          '</small>' +
          '</pre>'
        )
      } catch (__) {}
    }
    return `<pre><code class="${className}">${markdown.utils.escapeHtml(str)}</code></pre>`
  }
})
  .use(markdownAnchor, {
    level: [1, 2, 3],
    permalink: markdownAnchor.permalink.headerLink(),
    slugify: (text: string) => {
      // TODO unique id supported in the future
      return text
        .toLowerCase()
        .replace(/[/!@$%^&*()+=<>#?:"{}|,.;'`~[\]]/g, '')
        .trim()
        .replace(/^(\d)/g, '_' + '$1')
        .replace(/\s+/g, '-')
    },
    callback: (token, { slug, title }) => {
      const level = parseInt(token.tag.slice(1))
      const tag = token.tag
      const item: Toc = { slug, title, level, tag, children: [] }
      const index = tocLevels.indexOf(level)
      try {
        if (tocLevels.includes(level) && index === 0) {
          toc.push(item) // Top level
          flatToc.push(item)
        } else if (tocLevels.includes(level)) {
          let parent = toc[toc.length - 1]
          if (parent) {
            for (let i = tocLevels[1]; i < level; i++) {
              parent = parent.children![parent.children!.length - 1]
            }
            parent && parent.children?.push(item)
            flatToc.push(item)
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  })
  .use(markdownItCollapsible)
  .use(mathjax3)

export default defineNuxtPlugin((_nuxtApp) => {
  return {
    provide: {
      markdown: {
        render: (content: string, levels: number[] = [1, 2, 3]) => {
          toc.length = 0 // Clear the TOC array before rendering
          flatToc.length = 0
          tocLevels = levels
          return markdown.render(content)
        }
      },
      toc,
      flatToc
    }
  }
})
